import { render, staticRenderFns } from "./SummaryCallsVoip.vue?vue&type=template&id=f9d35108&scoped=true&"
import script from "./SummaryCallsVoip.vue?vue&type=script&lang=js&"
export * from "./SummaryCallsVoip.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCallsVoip.vue?vue&type=style&index=0&id=f9d35108&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d35108",
  null
  
)

export default component.exports